module.exports = __webpack_public_path__ + "img/mainImg_phone.0a950bce.png";